var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { instanceToPlain, plainToClass } from 'class-transformer';
import queries from 'constants/queries';
import { ClinicRoom } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from './ApiService';
var EMPTY_FILTERS = {};
var ClinicRoomService = /** @class */ (function (_super) {
    __extends(ClinicRoomService, _super);
    function ClinicRoomService() {
        var _this = _super.call(this) || this;
        _this.root = 'clinic_rooms';
        _this.successMessage = '';
        return _this;
    }
    ClinicRoomService.prototype.useClinicRooms = function (filters, enabled) {
        var _this = this;
        if (filters === void 0) { filters = EMPTY_FILTERS; }
        if (enabled === void 0) { enabled = true; }
        var params = {};
        if (filters.clinic_id != null) {
            params.clinic_id = filters.clinic_id;
        }
        if (filters.reception_desk_id != null) {
            params.reception_desk_id = filters.reception_desk_id;
        }
        if (filters.specialization_id != null) {
            params.specialization_id = filters.specialization_id;
        }
        return useQuery([queries.clinicRooms, filters], function () {
            return _this.get(_this.root, params);
        }, {
            enabled: enabled,
            retry: false,
            select: function (_a) {
                var data = _a.data;
                return plainToClass(ClinicRoom, (data || []));
            }
        });
    };
    ClinicRoomService.prototype.useGetClinicRoom = function (id) {
        var _this = this;
        return useQuery([queries.clinicRoom, id], function () { return _this.get("".concat(_this.root, "/").concat(id)); }, {
            enabled: id > 0,
            retry: false,
            select: function (_a) {
                var data = _a.data;
                return plainToClass(ClinicRoom, data);
            }
        });
    };
    ClinicRoomService.prototype.useCreateClinicRoom = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var clinicRoom = _a.clinicRoom, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.post(_this.root, {
                data: { clinic_room: instanceToPlain(clinicRoom) }
            });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.clinicRooms);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    ClinicRoomService.prototype.useUpdateClinicRoom = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var clinicRoom = _a.clinicRoom, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.put("".concat(_this.root, "/").concat(clinicRoom.getId()), {
                data: { clinic_room: instanceToPlain(clinicRoom) }
            });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.clinicRooms);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    ClinicRoomService.getInstance = function () {
        if (!ClinicRoomService.instance) {
            ClinicRoomService.instance = new ClinicRoomService();
        }
        return ClinicRoomService.instance;
    };
    return ClinicRoomService;
}(ApiService));
export default ClinicRoomService;
